module.exports = __webpack_public_path__ + "img/obs_swstg_flood.a393fafc.svg";